import { match } from 'ts-pattern'
import { Trans } from '@lingui/react/macro'


import { cls } from 'tagged-classnames-free';
export interface ITopContent {
  isCollapsed: boolean
  onClick: () => void
  prompt: string
}

export const TopContent = (props: ITopContent) => {
  const { isCollapsed, onClick, prompt } = props

  return (
    <div
      className={cls`
        relative
        z-20 
        flex 
        h-[32px]
        cursor-pointer
        items-center
        justify-between
        pl-4
      `}
    >
      <div
        className={cls`flex min-w-0 flex-1 items-center justify-start overflow-hidden`}
      >
        <span
          className={cls`text-f-text mr-1 flex flex-shrink-0 items-start text-base font-semibold`}
        >
          <Trans>Idea</Trans>
        </span>
        {match(isCollapsed)
          .with(true, () => (
            <span className='text-f-text-quaternary min-w-[20px] flex-1 truncate text-base font-semibold'>
              {prompt}
            </span>
          ))
          .otherwise(() => null)}
      </div>

      <div
        className={cls`
          flex h-full w-[48px] cursor-pointer items-center justify-center
        `}
        onClick={() => onClick?.()}
      >
        <span
          className={cls`
            i-com--up
            text-f-text-secondary 
            size-[18px] 
            transition-transform
            ${!isCollapsed ? '' : 'rotate-180'}
          `}
        />
      </div>
    </div>
  )
}
